/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_OVER_VIEW_DETAILS_REQUEST,
  FETCH_OVER_VIEW_DETAILS_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_FAILURE,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE,
} from "./OverViewDetailsTypes";

const initialState = {
  loading: false,
  error: "",
  overviewDetails: {},
  downloadOverViewData: {},
};

const handleRequest = (state) => ({
  ...state,
  loading: true,
});

const handleSuccess = (state, payload, dataKey) => ({
  ...state,
  loading: false,
  [dataKey]: payload,
  error: "",
});

const handleFailure = (state, payload, dataKey) => ({
  ...state,
  loading: false,
  [dataKey]: {},
  error: payload,
});

const overViewDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OVER_VIEW_DETAILS_REQUEST:
    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST:
      return handleRequest(state);

    case FETCH_OVER_VIEW_DETAILS_SUCCESS:
      return handleSuccess(state, action.payload, 'overviewDetails');

    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS:
      return handleSuccess(state, action.payload, 'downloadOverViewData');

    case FETCH_OVER_VIEW_DETAILS_FAILURE:
      return handleFailure(state, action.payload, 'overviewDetails');

    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE:
      return handleFailure(state, action.payload, 'downloadOverViewData');
    default:
      return state;
  }
};

export default overViewDetailsReducer;
